import { createContext, useContext, useState } from 'react';

const BusyIndicatorContext = createContext();
const BusyIndicatorActionContext = createContext();

/**
 * Context provider to show spinner accross application
 */
const BusyIndicatorContextProvider = ({ children }) => {
  const [isLoading, setLoader] = useState(false);

  return (
    <BusyIndicatorContext.Provider value={isLoading}>
      <BusyIndicatorActionContext.Provider value={setLoader}>
        {children}
      </BusyIndicatorActionContext.Provider>
    </BusyIndicatorContext.Provider>
  );
};

/**
 * React hook to use the value of `isLoading` provided by `NotificationProvider`. By using
 * this hook, you can show or hide loader.
 */
export const useLoader = () => useContext(BusyIndicatorContext);

/**
 * React hook to use `setLoader` provided by `NotificationProvider`. By using
 * this hook, you can set the state of your loader to `true` or `false`.
 */
export const useLoaderAction = () => useContext(BusyIndicatorActionContext);

export default BusyIndicatorContextProvider;
